module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: (_vm.className ? _vm.className + '-wrapper ' : '') + 'autocomplete-wrapper'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    class: (_vm.className ? _vm.className + '-input ' : '') + 'autocomplete-input',
    attrs: {
      "type": "text",
      "data-content": _vm.dataContent,
      "required": _vm.required,
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "name": _vm.name,
      "inputSetEventName": _vm.inputEventName,
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.type)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.type = $event.target.value
      }, function($event) {
        return _vm.input(_vm.type)
      }],
      "dblclick": _vm.showAll,
      "blur": _vm.hideAll,
      "keydown": _vm.keydown,
      "focus": _vm.focus
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList),
      expression: "showList"
    }],
    class: (_vm.className ? _vm.className + '-list ' : '') + 'autocomplete transition autocomplete-list'
  }, [_c('ul', _vm._l((_vm.json), function(data, i) {
    return _c('li', {
      class: _vm.activeClass(i),
      attrs: {
        "transition": "showAll"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectList(data)
        },
        "mousemove": function($event) {
          return _vm.mousemove(i)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.anchor ? data[_vm.anchor] : data))]), _vm._v(" "), (_vm.anchor) ? _c('span', [_vm._v(_vm._s(data[_vm.label]))]) : _vm._e()])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-589d526e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/components/autocomplete/autocomplete.vue
// module id = 571
// module chunks = 0